import { Navigate } from "react-router";

/** Settings index redirects to profile (default sub-page) */
export default function SettingsIndex() {
  return <Navigate to="/settings/profile" replace />;
}
